import { useEffect, useCallback } from 'react';
import { apiStatuses, baseUrl, errorMessage, sampleDataStatusId } from '../constantData';
import { useDemoMode } from './useDemoHook';
import { useSwitchToSampleModeMutation } from '../../../modules/authentication/slice/createAuthApiSlice';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsLoadingSampleData, setIsLoadingSampleData } from '../../../modules/createJob/slice/jobSlice';
import { useNavigate } from 'react-router-dom';

const useSampleDataStatus = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isDemoMode } = useDemoMode()
    const isLoadingSampleData = useSelector(selectIsLoadingSampleData)
    const [switchToSampleMode, { isError: switchError, isSuccess: switchSuccess }] = useSwitchToSampleModeMutation()

    const switchRequest = async () => {
        const data = await switchToSampleMode(!isDemoMode);
        if (data?.data.statusCode === apiStatuses.success) navigate(0)
        else message.error(errorMessage)
    }
    
    const preparingSampleData = useCallback(() => {
        dispatch(setIsLoadingSampleData(true))
        let eventSource: EventSource;
        try {
            eventSource = new EventSource(`${baseUrl}companies/sampleDataStatus`, { withCredentials: true });

            eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event?.data) as { statusCode: apiStatuses, sampleDataStatusId: sampleDataStatusId, message?: string }
                    if (data?.statusCode === apiStatuses.success) {

                        if (data.sampleDataStatusId === sampleDataStatusId.created) {
                            eventSource.close();
                            switchRequest()
                        } else if (data.sampleDataStatusId === sampleDataStatusId.failed) { 
                            eventSource.close();
                            dispatch(setIsLoadingSampleData(false))

                            message.error(errorMessage)
                        }

                    } else {
                        dispatch(setIsLoadingSampleData(false))

                        eventSource.close();
                        message.error(data.statusCode === apiStatuses.serverFailedProcessing ? data.message : errorMessage)
                    }
                } catch (e) {
                    eventSource.close();
                    dispatch(setIsLoadingSampleData(false))

                    message.error(errorMessage)
                }
            };

            eventSource.onerror = () => {
                message.error(errorMessage)
                eventSource.close();
                dispatch(setIsLoadingSampleData(false))

            };
        } catch (e) {
            message.error(errorMessage)
            dispatch(setIsLoadingSampleData(false))

        }
        // eslint-disable-next-line
    }, [isDemoMode])

    useEffect(() => {
        if (switchSuccess) navigate(0)
        else if (switchError) message.error(errorMessage)
    }, [switchSuccess, switchError, navigate])


    return { preparingSampleData, isLoadingSampleData };
};

export default useSampleDataStatus;